import React from "react";

const Select = ({ options, name, value, onChange, onBlur, error, touched,required }) => {
  return (
    <>
      <select
        id={name}
        name={name}
        className={`block w-full mt-1 rounded-md border border-gray-300 shadow-sm focus:border-red-clarin focus:ring-red-clarin sm:text-sm ${
          error && touched ? "border-red-500" : "" }`}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required={required} >
        <option value="">Seleccionar...</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && touched ? (
        <div className="text-red-500 mt-1">{error}</div>
      ) : null}
    </>
  );
};

export default Select;
